export default `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCl3fv5ujhXA4m8sKc3Sl8BdEIQ
aAhmcThz5vzkXJ6/F+RBNgqGr768F+51oKYf5q2nBjH55eRlpXkTYmobX4MM4bB7
/JbgUi8ESGjowZNab8NMlOszGNrxZGVJJN1z6NzQrYljPC/9ALXLcFWdHOXaMrsE
6Sk5rpWxTZ3tdCFgFQIDAQAB
-----END PUBLIC KEY-----`